import { LayerPluginInterface } from '../LayerInterface';
import TileLayer from 'ol/layer/Tile';
import { LayerBase } from './LayerBase';
import {BingMaps, OSM as OpenlayersOSM} from 'ol/source';
import BaseLayer from 'ol/layer/Base';
import {Feature} from "ol";
import VectorSource from "ol/source/Vector";
import {Openlayers} from "../../Openlayers";
import Styler from "../../Styler";
import {GeojsonLayerConfig} from "./Geojson";

export class Bing extends LayerBase implements LayerPluginInterface {

    protected layerConfig: {
        api_key:string
        imagery_set: string
    }

    constructor(openlayers: Openlayers, layer_id: string, weight: number) {
        super(openlayers, layer_id, weight);
        this.layerConfig = this.openlayers.mapConfig.getLayerConfig(this.layerId);
    }

    /**
     * Build the vector based layer.
     */
    buildLayer(): BaseLayer | null {
        return new TileLayer({
            zIndex: - this.weight,
            source: new BingMaps({
                key: this.layerConfig.api_key,
                imagerySet: this.layerConfig.imagery_set
            }),
        });
    }
}
